var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25.0003,
    height: 28,
    rx: 4,
    fill: "#2173FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.22046 5.55449L7.50101 4.57471L7.78156 5.55449C8.12232 6.7444 8.9873 7.67592 10.0922 8.0429L11.002 8.34502L10.0922 8.64715C8.9873 9.01413 8.12232 9.94565 7.78156 11.1356L7.50101 12.1153L7.22046 11.1356C6.8797 9.94565 6.01471 9.01413 4.9098 8.64715L4 8.34502L4.9098 8.0429C6.01471 7.67592 6.8797 6.7444 7.22046 5.55449Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.167 9.83472L13.7482 7.80518L14.3293 9.83472C15.0352 12.2995 16.8269 14.2291 19.1157 14.9893L21.0003 15.6151L19.1157 16.241C16.8269 17.0011 15.0352 18.9307 14.3293 21.3955L13.7482 23.4251L13.167 21.3955C12.4612 18.9307 10.6694 17.0011 8.38067 16.241L6.49609 15.6151L8.38067 14.9893C10.6694 14.2291 12.4612 12.2995 13.167 9.83472Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSms);
export default __webpack_public_path__ + "static/media/icon_sms.3f4df294acd20295add5f3adc64a0438.svg";
export { ForwardRef as ReactComponent };